import { inject, Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { Entity, Field } from '../model';
import { CustomService } from './custom.service';

@Injectable({
  providedIn: 'root',
})
export class SingleEntityService extends BaseService {
  private readonly customService = inject(CustomService);
  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getPredefinedSearchFlds(
    item,
    allEntityAttributes: any[],
    entityToSearch: Entity
  ): Field[] {
    if (item.for_entity === 'address') {
      return this.getPredefinedSearchFieldsForAddress(
        item,
        allEntityAttributes,
        entityToSearch
      );
    } else if (item.for_entity === 'prodrecipe') {
      return this.getPredefinedSearchFieldsForProdRecipe(
        allEntityAttributes,
        entityToSearch
      );
    } else if (item.for_entity === 'insurancepolicy') {
      return this.customService.getPredefinedSearchFieldsForInsurancePolicy(
        allEntityAttributes,
        entityToSearch
      );
    }
    return [];
  }

  private getPredefinedSearchFieldsForAddress(
    item,
    allEntityAttributes: any[],
    entityToSearch: Entity
  ) {
    let value = null;
    let searchFieldId = 0;

    const entityPrefix = item.fld_code_ent.split('_')[0];

    const indexSparePartLead = allEntityAttributes.findIndex(
      (x) => x.fld_code_ent === 'spare_part_lead'
    );
    const indexSparePartAccount = allEntityAttributes.findIndex(
      (x) => x.fld_code_ent === 'spare_part_account'
    );
    const indexMaintenanceFileLead = allEntityAttributes.findIndex(
      (x) => x.fld_code_ent === 'maintenance_file_lead'
    );
    const indexMaintenanceFileAccount = allEntityAttributes.findIndex(
      (x) => x.fld_code_ent === 'maintenance_file_account'
    );
    const indexEntityLead = allEntityAttributes.findIndex(
      (x) => x.fld_code_ent === `${entityPrefix}_lead`
    );
    const indexEntityAccount = allEntityAttributes.findIndex(
      (x) => x.fld_code_ent === `${entityPrefix}_account`
    );

    if (
      indexSparePartLead !== -1 &&
      allEntityAttributes[indexSparePartLead].value != null
    ) {
      value = allEntityAttributes[indexSparePartLead].value;
      searchFieldId =
        entityToSearch.fields.filter((x) => x.fld_code === 'address_lead')[0]
          ?.id ?? 0;
    } else if (
      indexSparePartAccount !== -1 &&
      allEntityAttributes[indexSparePartAccount].value != null
    ) {
      value = allEntityAttributes[indexSparePartAccount].value;
      searchFieldId =
        entityToSearch.fields.filter(
          (x) => x.fld_code === 'address_customer'
        )[0]?.id ?? 0;
    } else if (
      indexMaintenanceFileLead !== -1 &&
      allEntityAttributes[indexMaintenanceFileLead].value != null
    ) {
      value = allEntityAttributes[indexMaintenanceFileLead].value;
      searchFieldId =
        entityToSearch.fields.filter((x) => x.fld_code === 'address_lead')[0]
          ?.id ?? 0;
    } else if (
      indexMaintenanceFileAccount !== -1 &&
      allEntityAttributes[indexMaintenanceFileAccount].value != null
    ) {
      value = allEntityAttributes[indexMaintenanceFileAccount].value;
      searchFieldId =
        entityToSearch.fields.filter(
          (x) => x.fld_code === 'address_customer'
        )[0]?.id ?? 0;
    } else if (
      indexEntityLead !== -1 &&
      allEntityAttributes[indexEntityLead].value != null
    ) {
      value = allEntityAttributes[indexEntityLead].value;
      searchFieldId =
        entityToSearch.fields.filter((x) => x.fld_code === 'address_lead')[0]
          ?.id ?? 0;
    } else if (
      indexEntityAccount !== -1 &&
      allEntityAttributes[indexEntityAccount].value != null
    ) {
      value = allEntityAttributes[indexEntityAccount].value;
      searchFieldId =
        entityToSearch.fields.filter(
          (x) => x.fld_code === 'address_customer'
        )[0]?.id ?? 0;
    } else {
      return [];
    }

    let searchFields: Field[] = [];
    const accountSearchField: Field = new Field();
    accountSearchField.search_from = value;
    accountSearchField.id = searchFieldId;
    accountSearchField.fld_code = 'singleEntity';
    searchFields.push(accountSearchField);
    return searchFields;
  }

  private getPredefinedSearchFieldsForProdRecipe(
    allEntityAttributes: any[],
    entityToSearch: Entity
  ) {
    const indexProductionorderProduct = allEntityAttributes.findIndex(
      (x) => x.fld_code_ent === 'productionorder_product'
    );

    if (
      indexProductionorderProduct !== -1 &&
      allEntityAttributes[indexProductionorderProduct].value
    ) {
      const accountSearchField: Field = new Field();
      accountSearchField.search_from =
        allEntityAttributes[indexProductionorderProduct].value;
      accountSearchField.id =
        entityToSearch.fields.filter(
          (x) => x.fld_code === 'prodrecipe_product'
        )[0]?.id ?? 0;
      return [accountSearchField];
    }
    return [];
  }

  getConnectedEntdataIdFromField(item: any, allEntityAttributes: any[]) {
    if (item.for_entity === 'contact') {
      return this.customService.getConnectedAccountEntdataIdForContact(
        item,
        allEntityAttributes
      );
    }
    return null;
  }
}
